import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { guid } from 'app/shared/lib/guid';

@autoinject()
export class DemoEssDialogPage extends ComponentBase {

    protected typeOptions: string[] = ['save', 'cancel', 'add', 'attach', 'upload'];
    protected id: guid = guid();

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {
        super(...rest);
    }

    protected getState(state: number): string {
        switch(state) {
            case 1:
                return '1 - Open';
            case 2:
                return '2 - Closed';
            case 4:
                return '4 - Transitioning';
            case 5:
                return '5 - Opening';
            case 6:
                return '6 - Closing';
            default:
                return 'N/A';
        }
    }

    ////****************** Example 3 ********************************************////
    protected ex3IsDismissible: boolean = true;
    protected ex3DialogButtonText: string = 'Open Dialog Modal';
    protected ex3HeaderText: string = 'Header';
    protected ex3SubHeaderText: string = 'Sub Header';
    protected ex3ContentText: string = 'Content';
    protected ex3Button1Show: boolean = true;
    protected ex3Button2Show: boolean = true;
    protected ex3Button3Show: boolean = true;
    protected ex3Button1Type: string | null = null;
    protected ex3Button2Type: string | null = null;
    protected ex3Button1Text: string = 'Cancel';
    protected ex3Button2Text: string = 'OK';
    protected ex3Width: number = 3;
    protected ex3Height: number = 3;

}
